import React from 'react';
import { Button, ButtonProps, Spinner } from 'reactstrap';
import { useForm } from 'react-final-form';
import { QuestionnaireContext } from '../Contexts';

const style = { width: '6rem' };

const CompleteButton = (props: ButtonProps) => (
  <QuestionnaireContext.Consumer>
    {({ onComplete }) => (
      <Button {...props} onClick={onComplete} color="success" style={style}>
        Complete
      </Button>
    )}
  </QuestionnaireContext.Consumer>
);

const BackButton = (props: ButtonProps) => (
  <QuestionnaireContext.Consumer>
    {({ onPrevious }) => (
      <Button {...props} onClick={onPrevious} style={style}>
        Back
      </Button>
    )}
  </QuestionnaireContext.Consumer>
);

const SaveAndNextButton = (
  props: ButtonProps & {
    saving: boolean;
    disabled: boolean;
    submit: () => Promise<object | undefined> | undefined;
  },
) => (
  <QuestionnaireContext.Consumer>
    {({ onNext, last, complete }) => {
      if (last) {
        return <CompleteButton disabled={props.disabled || !complete} />;
      }
      return (
        <Button
          disabled={props.disabled}
          onClick={async () => {
            try {
              const res = await props.submit();
              console.log('res', res);
              if (!res) {
                window.scrollTo(0, 0);
                onNext();
              }
            } catch (e) {
              console.error(e);
            }
          }}
          className={props.className}
          style={style}
          color="success">
          {props.saving ? <Spinner size="sm"></Spinner> : 'Next'}
        </Button>
      );
    }}
  </QuestionnaireContext.Consumer>
);

const QuestionnaireFormNavigation = () => {
  const form = useForm();
  const state = form.getState();
  return (
    <QuestionnaireContext.Consumer>
      {({ first }) => (
        <>
          {<BackButton disabled={state.dirty || !!first} />}
          <SaveAndNextButton
            className="ml-auto mr-1"
            submit={form.submit}
            disabled={state.hasValidationErrors || state.hasSubmitErrors}
            saving={state.submitting}
          />
        </>
      )}
    </QuestionnaireContext.Consumer>
  );
};

export default QuestionnaireFormNavigation;
